export const INIT_ADMIN_SAV = "store/sav/INIT_ADMIN_SAV";
export const INIT_ADMIN_SAV_COMPLETED = "store/sav/INIT_ADMIN_SAV_COMPLETED";
export const INIT_ADMIN_SAV_FAILED = "store/sav/INIT_ADMIN_SAV_FAILED";

export const SAV_SEND_SMS = "store/sav/SAV_SEND_SMS";
export const SAV_SEND_SMS_COMPLETED = "store/sav/SAV_SEND_SMS_COMPLETED";
export const SAV_SEND_SMS_FAILED = "store/sav/SAV_SEND_SMS_FAILED";

export const SAV_SEND_EMAIL = "store/sav/SAV_SEND_EMAIL";
export const SAV_SEND_EMAIL_COMPLETED = "store/sav/SAV_SEND_EMAIL_COMPLETED";
export const SAV_SEND_EMAIL_FAILED = "store/sav/SAV_SEND_EMAIL_FAILED";

export const SAV_CREDIT_POOLS = "store/sav/SAV_CREDIT_POOLS";
export const SAV_CREDIT_POOLS_COMPLETED = "store/sav/SAV_CREDIT_POOLS_COMPLETED";
export const SAV_CREDIT_POOLS_FAILED = "store/sav/SAV_CREDIT_POOLS_FAILED";

export const SAV_PROP_LIST = "store/sav/SAV_PROP_LIST";
export const SAV_PROP_LIST_COMPLETED = "store/sav/SAV_PROP_LIST_COMPLETED";
export const SAV_PROP_LIST_FAILED = "store/sav/SAV_PROP_LIST_FAILED";

export const SAV_PROP_CREATE = "store/sav/SAV_PROP_CREATE";
export const SAV_PROP_CREATE_COMPLETED = "store/sav/SAV_PROP_CREATE_COMPLETED";
export const SAV_PROP_CREATE_FAILED = "store/sav/SAV_PROP_CREATE_FAILED";

export const SAV_PROP_CANCEL = "store/sav/SAV_PROP_CANCEL";
export const SAV_PROP_CANCEL_COMPLETED = "store/sav/SAV_PROP_CANCEL_COMPLETED";
export const SAV_PROP_CANCEL_FAILED = "store/sav/SAV_PROP_CANCEL_FAILED";

export const SAV_PROP_SET_CATEGORY = "store/sav/SAV_PROP_SET_CATEGORY";
export const SAV_PROP_SET_CATEGORY_COMPLETED = "store/sav/SAV_PROP_SET_CATEGORY_COMPLETED";
export const SAV_PROP_SET_CATEGORY_FAILED = "store/sav/SAV_PROP_SET_CATEGORY_FAILED";

// Un SAV désigné par son avantage (lien « éditer la catégorie » du dashboard)
export const SAV_ADVANTAGE_GET = "store/sav/SAV_ADVANTAGE_GET";
export const SAV_ADVANTAGE_GET_COMPLETED = "store/sav/SAV_ADVANTAGE_GET_COMPLETED";
export const SAV_ADVANTAGE_GET_FAILED = "store/sav/SAV_ADVANTAGE_GET_FAILED";
export const SAV_ADVANTAGE_SET_CATEGORY = "store/sav/SAV_ADVANTAGE_SET_CATEGORY";
export const SAV_ADVANTAGE_SET_CATEGORY_COMPLETED = "store/sav/SAV_ADVANTAGE_SET_CATEGORY_COMPLETED";
export const SAV_ADVANTAGE_SET_CATEGORY_FAILED = "store/sav/SAV_ADVANTAGE_SET_CATEGORY_FAILED";

export const SAV_ITINERARIES = "store/sav/SAV_ITINERARIES";
export const SAV_ITINERARIES_COMPLETED = "store/sav/SAV_ITINERARIES_COMPLETED";
export const SAV_ITINERARIES_FAILED = "store/sav/SAV_ITINERARIES_FAILED";

export const INTENDANCE_DELIVERYMEN = "store/sav/INTENDANCE_DELIVERYMEN";
export const INTENDANCE_DELIVERYMEN_COMPLETED = "store/sav/INTENDANCE_DELIVERYMEN_COMPLETED";
export const INTENDANCE_DELIVERYMEN_FAILED = "store/sav/INTENDANCE_DELIVERYMEN_FAILED";

export const INTENDANCE_SET_ASSIGNMENT = "store/sav/INTENDANCE_SET_ASSIGNMENT";
export const INTENDANCE_SET_ASSIGNMENT_COMPLETED = "store/sav/INTENDANCE_SET_ASSIGNMENT_COMPLETED";
export const INTENDANCE_SET_ASSIGNMENT_FAILED = "store/sav/INTENDANCE_SET_ASSIGNMENT_FAILED";

export const INTENDANCE_STAFF = "store/sav/INTENDANCE_STAFF";
export const INTENDANCE_STAFF_COMPLETED = "store/sav/INTENDANCE_STAFF_COMPLETED";
export const INTENDANCE_STAFF_FAILED = "store/sav/INTENDANCE_STAFF_FAILED";

export const INTENDANCE_SET_STAFF = "store/sav/INTENDANCE_SET_STAFF";
export const INTENDANCE_SET_STAFF_COMPLETED = "store/sav/INTENDANCE_SET_STAFF_COMPLETED";
export const INTENDANCE_SET_STAFF_FAILED = "store/sav/INTENDANCE_SET_STAFF_FAILED";

export const INTENDANCE_SET_DELIVERED = "store/sav/INTENDANCE_SET_DELIVERED";
export const INTENDANCE_SET_DELIVERED_COMPLETED = "store/sav/INTENDANCE_SET_DELIVERED_COMPLETED";
export const INTENDANCE_SET_DELIVERED_FAILED = "store/sav/INTENDANCE_SET_DELIVERED_FAILED";

export const INTENDANCE_DELIVERED_SPOTS = "store/sav/INTENDANCE_DELIVERED_SPOTS";
export const INTENDANCE_DELIVERED_SPOTS_COMPLETED = "store/sav/INTENDANCE_DELIVERED_SPOTS_COMPLETED";
export const INTENDANCE_DELIVERED_SPOTS_FAILED = "store/sav/INTENDANCE_DELIVERED_SPOTS_FAILED";

export const INTENDANCE_NOTES = "store/sav/INTENDANCE_NOTES";
export const INTENDANCE_NOTES_COMPLETED = "store/sav/INTENDANCE_NOTES_COMPLETED";
export const INTENDANCE_NOTES_FAILED = "store/sav/INTENDANCE_NOTES_FAILED";

export const INTENDANCE_SEND_HISTORY = "store/sav/INTENDANCE_SEND_HISTORY";
export const INTENDANCE_SEND_HISTORY_COMPLETED = "store/sav/INTENDANCE_SEND_HISTORY_COMPLETED";
export const INTENDANCE_SEND_HISTORY_FAILED = "store/sav/INTENDANCE_SEND_HISTORY_FAILED";

export const INTENDANCE_RECAP_CONNECTEAM = "store/sav/INTENDANCE_RECAP_CONNECTEAM";
export const INTENDANCE_RECAP_CONNECTEAM_COMPLETED = "store/sav/INTENDANCE_RECAP_CONNECTEAM_COMPLETED";
export const INTENDANCE_RECAP_CONNECTEAM_FAILED = "store/sav/INTENDANCE_RECAP_CONNECTEAM_FAILED";

export const INTENDANCE_NOTE_CREATE = "store/sav/INTENDANCE_NOTE_CREATE";
export const INTENDANCE_NOTE_CREATE_COMPLETED = "store/sav/INTENDANCE_NOTE_CREATE_COMPLETED";
export const INTENDANCE_NOTE_CREATE_FAILED = "store/sav/INTENDANCE_NOTE_CREATE_FAILED";

export const SAV_PROP_CATEGORIES = "store/sav/SAV_PROP_CATEGORIES";
export const SAV_PROP_CATEGORIES_COMPLETED = "store/sav/SAV_PROP_CATEGORIES_COMPLETED";
export const SAV_PROP_CATEGORIES_FAILED = "store/sav/SAV_PROP_CATEGORIES_FAILED";

export const SAV_PROP_FRESHDESK = "store/sav/SAV_PROP_FRESHDESK";
export const SAV_PROP_FRESHDESK_COMPLETED = "store/sav/SAV_PROP_FRESHDESK_COMPLETED";
export const SAV_PROP_FRESHDESK_FAILED = "store/sav/SAV_PROP_FRESHDESK_FAILED";

export const SAV_PROP_RESPONSE_PREVIEW = "store/sav/SAV_PROP_RESPONSE_PREVIEW";
export const SAV_PROP_RESPONSE_PREVIEW_COMPLETED = "store/sav/SAV_PROP_RESPONSE_PREVIEW_COMPLETED";
export const SAV_PROP_RESPONSE_PREVIEW_FAILED = "store/sav/SAV_PROP_RESPONSE_PREVIEW_FAILED";

export const SAV_PROP_BAREME = "store/sav/SAV_PROP_BAREME";
export const SAV_PROP_BAREME_COMPLETED = "store/sav/SAV_PROP_BAREME_COMPLETED";
export const SAV_PROP_BAREME_FAILED = "store/sav/SAV_PROP_BAREME_FAILED";

export const SAV_PROP_ORDER_ITEMS = "store/sav/SAV_PROP_ORDER_ITEMS";
export const SAV_PROP_ORDER_ITEMS_COMPLETED = "store/sav/SAV_PROP_ORDER_ITEMS_COMPLETED";
export const SAV_PROP_ORDER_ITEMS_FAILED = "store/sav/SAV_PROP_ORDER_ITEMS_FAILED";

export const SAV_PROP_CUSTOMER_HISTORY = "store/sav/SAV_PROP_CUSTOMER_HISTORY";
export const SAV_PROP_CUSTOMER_HISTORY_COMPLETED = "store/sav/SAV_PROP_CUSTOMER_HISTORY_COMPLETED";
export const SAV_PROP_CUSTOMER_HISTORY_FAILED = "store/sav/SAV_PROP_CUSTOMER_HISTORY_FAILED";

export const SAV_PROP_COMPENSATION_SUGGESTION = "store/sav/SAV_PROP_COMPENSATION_SUGGESTION";
export const SAV_PROP_COMPENSATION_SUGGESTION_COMPLETED = "store/sav/SAV_PROP_COMPENSATION_SUGGESTION_COMPLETED";
export const SAV_PROP_COMPENSATION_SUGGESTION_FAILED = "store/sav/SAV_PROP_COMPENSATION_SUGGESTION_FAILED";

export const SAV_PROP_RESPONSE_TEMPLATES = "store/sav/SAV_PROP_RESPONSE_TEMPLATES";
export const SAV_PROP_RESPONSE_TEMPLATES_COMPLETED = "store/sav/SAV_PROP_RESPONSE_TEMPLATES_COMPLETED";
export const SAV_PROP_RESPONSE_TEMPLATES_FAILED = "store/sav/SAV_PROP_RESPONSE_TEMPLATES_FAILED";

export const SAV_PROP_CUSTOMER_ORDERS = "store/sav/SAV_PROP_CUSTOMER_ORDERS";
export const SAV_PROP_CUSTOMER_ORDERS_COMPLETED = "store/sav/SAV_PROP_CUSTOMER_ORDERS_COMPLETED";
export const SAV_PROP_CUSTOMER_ORDERS_FAILED = "store/sav/SAV_PROP_CUSTOMER_ORDERS_FAILED";

export const SAV_PROP_CUSTOMER_LIST = "store/sav/SAV_PROP_CUSTOMER_LIST";
export const SAV_PROP_CUSTOMER_LIST_COMPLETED = "store/sav/SAV_PROP_CUSTOMER_LIST_COMPLETED";
export const SAV_PROP_CUSTOMER_LIST_FAILED = "store/sav/SAV_PROP_CUSTOMER_LIST_FAILED";
